export class Section<T> {
  id: string;
  order: number;
  componentName: string;
  sectionData: T;
  articleId?: string;
}
